import React from 'react';
import SupersearchAIActions from './SupersearchAIActions';
import SupersearchProspectingResults, { type ProspectingSearchResult } from './SupersearchProspectingResults';

type ProspectingData = {
	results: ProspectingSearchResult[];
	loading: boolean;
	error: boolean;
	onCompanyAdded: () => void;
};

type SupersearchNoResultsProps = {
	query: string;
	closeSearch: () => void;
	prospecting?: ProspectingData;
	onAddCompany?: () => void;
};

const SearchTips = ({ lang }: { lang: Record<string, string> }) => (
	<div className="search-tips">
		<h4 className="search-tips-title">{lang.searchSmartInUpsales}</h4>
		<div className="search-tips-column">
			<div className="search-tips-column-title">{lang.phone}</div>
			<div>{lang.phonenumberExplanation}</div>
		</div>
		<div className="search-tips-column">
			<div className="search-tips-column-title">{lang.shortcut}</div>
			<div>
				{lang.shortcutExplanation}{' '}
				<span
					style={{ width: Tools.browserService.isOSX() ? '30px' : '46px' }}
					className="search-tips-keycontainer"
				>
					{Tools.browserService.isOSX() ? '⌘' : 'CTRL'}
				</span>
				{' + '}
				<span style={{ width: '30px' }} className="search-tips-keycontainer">
					{'K'}
				</span>
			</div>
		</div>
	</div>
);

const SupersearchNoResults = ({ query, closeSearch, prospecting, onAddCompany }: SupersearchNoResultsProps) => {
	const t = Tools.$translate;

	const lang = {
		searchSmartInUpsales: t('navbar.quickSearch.searchSmartInUpsales'),
		phonenumberExplanation: t('navbar.quickSearch.phonenumberExplanation'),
		phone: t('tag.contact.phone'),
		shortcut: t('navbar.quickSearch.shortcut'),
		shortcutExplanation: t('navbar.quickSearch.shortcutExplanation'),
		lastResort: t('navbar.quickSearch.prospecting.lastResort'),
		lastResortDescription: t('navbar.quickSearch.prospecting.lastResortDescription'),
		createManually: t('default.createManually')
	};

	if (prospecting) {
		return (
			<div className="supersearch-noresults-prospecting">
				<SupersearchAIActions query={query} closeSearch={closeSearch} />
				<div className="supersearch-noresults-prospecting__prospecting">
					<SupersearchProspectingResults
						results={prospecting.results}
						loading={prospecting.loading}
						error={prospecting.error}
						onCompanyAdded={prospecting.onCompanyAdded}
					/>
				</div>
				<div className="supersearch-noresults-prospecting__footer">
					<div className="supersearch-noresults-prospecting__footer-left">
						<SearchTips lang={lang} />
					</div>
					<div className="supersearch-noresults-prospecting__footer-right">
						<div className="supersearch-noresults-prospecting__last-resort-title">
							{lang.lastResort}
						</div>
						<div className="supersearch-noresults-prospecting__last-resort-description">
							{lang.lastResortDescription}
						</div>
						{onAddCompany ? (
							<button
								className="supersearch-noresults-prospecting__create-manually-btn"
								type="button"
								onClick={onAddCompany}
							>
								{'+ ' + lang.createManually}
							</button>
						) : null}
					</div>
				</div>
			</div>
		);
	}

	return (
		<div>
			<SupersearchAIActions query={query} closeSearch={closeSearch} />
			<SearchTips lang={lang} />
		</div>
	);
};

export default SupersearchNoResults;
